import { useState } from "react";

export const labOrdersViews = {
  list: "list",
  newOrder: "newOrder",
  details: "details",
};

export const useLabOrdersView = () => useState(labOrdersViews.list);
